export default __webpack_public_path__ + "static/media/goodPopup.dce13e94.svg";